// extracted by mini-css-extract-plugin
module.exports = {"versionMessageContainer":"DocumentVersionMessage_versionMessageContainer__wS7rJ","closeVersion":"DocumentVersionMessage_closeVersion__2S8jq"};